<script setup>
  import { storeToRefs } from "pinia";
  import { ListContainer } from "@/components/episto-ui/list";
  import { ListItem } from "@/components/episto-ui/list";
  import { useMGroupsStore } from "@stores/mGroups";

  const mGroupsStore = useMGroupsStore();
  const { mGroups } = storeToRefs(mGroupsStore);
  const { selectMGroup, duplicateMGroup, addMGroup, removeMGroup, isRemovableMGroup, isMGroupSelected } = mGroupsStore;
</script>

<template>
  <ListContainer
    element-name="campaign"
    :add-element="addMGroup"
    :show-header="false">
    <template #elements>
      <ListItem
        v-for="(group, index) in mGroups"
        :key="`group-item-${index}`"
        :index="index"
        :element-title="group.name"
        :select-element="selectMGroup"
        :is-element-selected="isMGroupSelected"
        :duplicate-element="duplicateMGroup"
        :delete-element="isRemovableMGroup(group) ? () => removeMGroup(index) : null" />
    </template>
  </ListContainer>
</template>
